var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM41(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5453_41795",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5453_41795",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB8ElEQVRo3u2ay07CQBSGWeiKsIOngJYFpqhg4gNACOyIgQTfAPasINEncOkTSHwNEYpxCTExsZW9CwhekvEc0mpTLgWdMnPQSb4Nl873l3aYmdNA4L99N0NJh4B94ASoAXWLmvUavheSR1hNoXQCOAN6wAfAPMDP3AHnwJ4RSwk507tABbhfQdgLPMYpHtN38Wc1jfJ54IGDuBs8ZsFU0r6d9Qhw7YO4G+wjwlteA8wNyNtgX0le8hlgvEF5G+wzy0P+VYC8zduPQ1iXzUigvPOX0NaVDwOGBPI26BJeSd6MT4fKlkTyNq2herTS2c9JKG+T85LfAfoSBxig47IAJYnlbcpz5R+jxxigSyCAPlQOZgNM2nr85eKSUWBy043PBGCMNRid1pwXoEMoQMctHwTeCQVA16AzgMboNc0ZoEgwQNEZoEowQNUZoE4wQH2rApC/hMjfxOSHUdp/ZASnErfz5kJNQgEas9NpmKKSmU63dXXRYl4nsKDp4uJr0ZKyTCBAyWtRP5BYvr90UU9+W2V6L0Sl3di6eood/oGtRdfm7lgC+dHam7uOEFnB2+vYd+a3NYKswAJHhleVJimgxKTxrpPRLfJ9DbHKdIgt+FhmzRsxn8qsPhe6KxspdHN81KBnfSdhinjUYGse9pChfQLbSzxlTNYspwAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM41);
export default __webpack_public_path__ + "static/media/m41.409d4bbd7b79b544866b3b40ddaf371e.svg";
export { ForwardRef as ReactComponent };